import { render, staticRenderFns } from "./ShopNote.vue?vue&type=template&id=67d90e0c&"
import script from "./ShopNote.vue?vue&type=script&lang=js&"
export * from "./ShopNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports